import { useEffect, useRef } from 'react';

const publisherLogos = [

  {
    id: 1,
    image: 'https://static.readdy.ai/image/8d92607123ebd7e39393fafa79bd6936/67e63c5a2cb0f7953679091ce8f00bcd.png',
    invert: true,
  },
  {
    id: 2,
    image: 'https://static.readdy.ai/image/8d92607123ebd7e39393fafa79bd6936/8353b538fa6fe9173b4b073dddef446f.png',
    invert: true,
  },
  {
    id: 3,
    image: 'https://static.readdy.ai/image/8d92607123ebd7e39393fafa79bd6936/1c324d2724d82edf9d7fa1e906ca706c.png',
    invert: true,
  },
  {
    id: 4,
    image: 'https://static.readdy.ai/image/8d92607123ebd7e39393fafa79bd6936/3f2065c093b310ed3e08e9ef3ca5e380.png',
    invert: true,
  },
  {
    id: 5,
    image: 'https://static.readdy.ai/image/8d92607123ebd7e39393fafa79bd6936/dc674177875c2604762041db1f282d64.png',
    invert: true,
  },
  {
    id: 6,
    image: 'https://static.readdy.ai/image/8d92607123ebd7e39393fafa79bd6936/248f137aed3a32d187d1cfa2f34dfb44.png',
    invert: true,
  },
];

// Marquee'nin kesintisiz dönmesi için listeyi iki kere çoğaltıyoruz
const logoItems = [...publisherLogos, ...publisherLogos];

export default function PublisherMarquee() {
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    let animationId: number;
    let offset = 0;

    const step = () => {
      offset -= 0.4;
      const halfWidth = el.scrollWidth / 2;
      if (Math.abs(offset) >= halfWidth) {
        offset = 0;
      }
      el.style.transform = `translateX(${offset}px)`;
      animationId = requestAnimationFrame(step);
    };

    animationId = requestAnimationFrame(step);
    return () => cancelAnimationFrame(animationId);
  }, []);

  return (
    <section className="py-16 lg:py-20 bg-stone-50 overflow-hidden">
      <div className="relative w-full">
        <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-stone-50 to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-stone-50 to-transparent z-10 pointer-events-none" />

        <div
          ref={scrollRef}
          className="flex items-center will-change-transform"
          style={{ width: 'max-content' }}
        >
          {logoItems.map((logo, index) => (
            <div
              key={`${logo.id}-${index}`}
              className="flex-shrink-0 mx-10 lg:mx-14 flex items-center justify-center"
              style={{ width: '240px', height: '96px' }}
            >
              <img
                src={logo.image}
                alt="Publisher logo"
                className="max-h-[72px] w-auto object-contain"
                style={logo.invert ? { filter: 'invert(1)' } : undefined}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
